module.exports = __webpack_public_path__ + "img/dict.2185096b.svg";